import { ReactNode } from "react";
import cx from "classnames";
import ReactModal from "react-modal";
import { Heading } from "../Type";
import { X } from "../Icons/general-interface-1";
import styles from "./index.module.scss";

type PropsType = {
  children: ReactNode;
  onClose?: () => void;
  title?: string;
  isOpen: boolean;
  className?: string;
  closeOnOverlay?: boolean;
};

ReactModal.setAppElement("#root");

const Modal = ({ children, onClose, title, isOpen, closeOnOverlay, className, ...rest }: PropsType) => {
  return (
    <ReactModal
      isOpen={isOpen}
      className={cx(styles.modal,className)}
      overlayClassName={styles.overlay}
      bodyOpenClassName={styles.open}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={closeOnOverlay}
      {...rest}
    >
      <div className={styles.modalHeader}>
        <Heading size="h3">{title}</Heading>
        <button type="button" className={styles.button} onClick={onClose}>
          <X width={24} height={24} />
        </button>
      </div>
      <div className={cx(styles.modalBody)}>{children}</div>
    </ReactModal>
  );
};

export default Modal;
